import React, { useState } from 'react';

import { TableWrapper } from '../../components';
import { IS_ADMIN } from '../../config';
import { useFetchDsiputes } from '../../hooks/queries';
import { ResolveButton, ResolveDisputeModal } from './resolve';

function Disputes() {
  const {
    disputes,
    setSearchQuery,
    isRefetching,
    setStatus,
    isLoading,
    filterByDate,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    status,
    searchQuery
  } = useFetchDsiputes();

  // Merchants resolve disputes from the row; admins keep the read-only view.
  const [activeDispute, setActiveDispute] = useState(null);

  const formattedData = disputes.map((dispute) => {
    const { amount, currency_slug } = dispute;
    const amount_currency = `${amount} ${(currency_slug || '').toUpperCase()}`;
    return {
      ...dispute,
      amount_currency
    };
  });
  let showIsFetching =
    (!disputes.length && isLoading) || ((searchQuery || status) && isRefetching) || false;
  return (
    <div className="disputes">
      <TableWrapper
        data={formattedData}
        title={IS_ADMIN ? 'All' : 'Your'}
        name="disputes"
        headerName="disputes"
        hasFilters
        isFetching={showIsFetching}
        isLoading={isFetchingNextPage}
        searchPlaceholder="Search disputes"
        onSearch={setSearchQuery}
        onStatusChange={setStatus}
        onDateFilter={filterByDate}
        canLoadMore={hasNextPage}
        onLoadMore={fetchNextPage}
        rowAction={
          IS_ADMIN
            ? undefined
            : (dispute) => <ResolveButton dispute={dispute} onResolve={setActiveDispute} />
        }
      />
      {activeDispute && (
        <ResolveDisputeModal dispute={activeDispute} onClose={() => setActiveDispute(null)} />
      )}
    </div>
  );
}

export { Disputes };
